export default "../images/ajax-loader.gif";